import alerts from "./alerts.json";
import form from "./form.json";
import header from "./header.json";
import list from "./list.json";

const AddonConfig = {
    alerts,
    form,
    header,
    list
};

export default AddonConfig;